import { MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

const languages = ["nl", "fr", "en"];

export default function LanguageSelector() {
  const { i18n, t } = useTranslation();

  const currentLanguage =
    i18n.resolvedLanguage?.split("-")[0] || "nl";

  return (
    <Select
      value={currentLanguage}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      variant="standard"
      disableUnderline
      inputProps={{ "aria-label": t("navigation.selectLanguage") }}
      sx={{
        color: "white",
        minWidth: 45,
        fontWeight: 600,

        "& .MuiSelect-icon": {
          color: "white",
        },
      }}
    >
      {languages.map((language) => (
        <MenuItem key={language} value={language}>
          {language.toUpperCase()}
        </MenuItem>
      ))}
    </Select>
  );
}
